import MarketplaceManagePage from "../../../careMarketplace/pages/marketplaceManagePage";
import Portal from "../../../../../platform/pages/business/portal";

const MarketplacePortal = (props: any) => {
  return <Portal TabComponent={MarketplaceManagePage} title={"Marketplace"} props={props} />;
};

export default MarketplacePortal;

